; (function ($, window, document, undefined) {
    'use strict';
    // nom de librairie à modifier
    Foundation.libs.espaceclient = {
        name: 'espaceclient',

        version: '1.0.0',

        settings: {
            callback: function () { }
        },

        init: function (scope, method, options) {
            // initialisation à conserver
            Foundation.inherit(this, 'throttle random_str');
            var self = this;

            this.settings = this.settings || $.extend({}, this.defaults, (options || method));


            // à conserver
            this.bindings(method, options);
            this.initBindings();
        },

        events: function () {
            var self = this;
            var S = this.S;

            this.initBindings();

            //////////////////////////////////////////////////////////////
            //                          ETAPE1                          //
            //////////////////////////////////////////////////////////////
            $(this.scope).ready(function (event) {
                var $erreur = $('#displayerreur');

                if ($erreur.length) {
                    $('#erreur-globale .error-text').html($erreur.val());
                    $('#erreur-globale').foundation('reveal', 'open');
                }
            });
        },

        initBindings: function () {
            initInputPasswordToggle();
            this.initOrderDetails();
            $(this.scope)
                .off('.espaceclient')
                .on('change paste keyup select.fndtn.espaceclient', '.passwordValidation', function (e) {
                    Foundation.libs.espaceclient.activatePasswordControl(e);
                })
                .on('click.fndtn.espaceclient', '.advantage__more', function (e) {
                    e.preventDefault();
                    $(this).parents('.advantage').toggleClass("-active")
                })
                .on('click.fndtn.espaceclient', '.advantage__close', function (e) {
                    e.preventDefault();
                    $(this).parents('.advantage').toggleClass("-active")
                })
                .on('click.fndtn.espaceclient', '.advantages__more', function (e) {
                    e.preventDefault();
                    var label = $(this).data("toggle");
                    var content = $(this).text();
                    $(this).text(label);
                    $(this).data("toggle", content);
                    $('.advantages__list').toggleClass("-active")
                });
        },

        activatePasswordControl: function (event) {
            var $elem = $(event.currentTarget).parents('.m-inputWrapper');
            var value = event.currentTarget.value;
            var className = "-valid";
            var options = {
                lowerCase: /[a-z]/g,
                upperCase: /[A-Z]/g,
                int: /[0-9]/g,
                nb: [8, 16]
            }
            if (value.match(options.lowerCase)) {
                $elem.find('*[data-id="lower"]').addClass(className);
            } else {
                $elem.find('*[data-id="lower"]').removeClass(className);
            }

            if (value.match(options.upperCase)) {
                $elem.find('*[data-id="upper"]').addClass(className);
            } else {
                $elem.find('*[data-id="upper"]').removeClass(className);
            }

            if (value.match(options.int)) {
                $elem.find('*[data-id="int"]').addClass(className);
            } else {
                $elem.find('*[data-id="int"]').removeClass(className);
            }

            if (value.length >= options.nb[0] && value.length <= options.nb[1]) {
                $elem.find('*[data-id="nb"]').addClass(className);
            } else {
                $elem.find('*[data-id="nb"]').removeClass(className);
            }
        },

        initOrderDetails: () => {
            if ($(".commande").length == 0) return;
            console.log('charge');

            const trackingArea = $('.colis__tracking');
            if (trackingArea.length == 0) return;

            const activeStep = trackingArea.data("active-item");
            const trackingSteps = trackingArea.find(".steps__item");
            const trackingIndicator = trackingArea.find(".tracking__indicator");

            trackingSteps.each((i, step) => {
                if (i <= activeStep) {
                    $(step).addClass("-active");
                    console.log(step);
                    trackingIndicator.css("left", step.offsetLeft)
                }
            })
        },

        OnSuccessCreateAccount: function (result) {
            if (result.IsValid) {


                if (result.IsRedirect) {
                    window.location.href = result.Redirect;
                }
                else {
                    Foundation.libs.common.hidePreloader();
                }
            } else {
                if (result.IsRedirect) {
                    window.location.href = result.Redirect;
                } else {
                    $('#identification').html(result._CreationCompte);
                    Foundation.libs.common.hidePreloader();
                }
            }
        },

        OnSuccessModifierMesInfosPerso: function (result) {
            if (result.IsValid) {
                Foundation.libs.common.updateAccount();
            }

            $('#mes-infos-wrapper').html(result._MesInfosPerso);
        },

        reflow: function () { }
    };
}(jQuery, window, window.document));

